module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABFUExURRhs9RVp9Bds9Rdr9RZo8Rds9RZs9kdwTBhr9RFl6xZq9BVp9BFo9BVr9Bds9RZq9Bds9Bdr9Rhr9Rds9hds9Bdr9Rhs9WlJzPkAAAAWdFJOU38qzbUg+3EA3wxDUhY58lzW5sOVvaYSGKiJAAAAiUlEQVQY052QyRLDIAxDzWazJkAS//+nxrRpO+WSmejA4SHJBiiVJ2kFVcMk34GBJoF/BNH+wdwVkeVEZQ9fuC9iWtmSWo4PBPEQbY3GDb6hctuo0mach8svGHyVpuBQWG76ihcnTZGLQCPt1yDkSOjEnnj97ZkC5TjS8fkz76D28yc3A6r7Scae/sQManilt6EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/header/select-title1.png
// module id = 04N4
// module chunks = 0